import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { AuthService } from '../../auth'

export const USER_QUERY_KEY = 'user'

export const getUserQuery = () => ({
  queryKey: [USER_QUERY_KEY],
  queryFn: () => AuthService.getCurrentUser(),
  placeholderData: keepPreviousData,
  staleTime: Number.POSITIVE_INFINITY,
  refetchOnMount: false,
  refetchOnWindowFocus: false
})

export const useUser = () => {
  return useQuery(getUserQuery())
}
